import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/BillOfLading/components/SectionPitch/SectionPitch.module.scss';

const cn = classNames.bind(styles);

const SectionPitch = (): ReactElement => {
  return (
    <section className={cn('pitch')}>
      <div className={cn('container')}>

        <h2 className={cn('pitch__heading')}>
          <span>Who does</span>
          <span> a Bill of Lading involve?</span>
        </h2>

        <p className={cn('pitch__heading-description')}>
          Three people are directly connected to a Bill of Lading for any and all shipments:
        </p>

        <div className={cn('pitch__paragraphs')}>
          <p className={cn('pitch__paragraph')}>
            The shipper is the entity providing the goods for transport. They handle the packing and preparation of
            the shipment, which could be a supplier or your own warehouse or manufacturing facility.
          </p>
          <p className={cn('pitch__paragraph')}>
            The carrier is the entity responsible for moving the cargo, such as Maersk or any other shipping line,
            trucking company, or airline.
          </p>
          <p className={cn('pitch__paragraph')}>
            The consignee is the designated recipient of the shipment, which could be your company or a manufacturer
            that requires the parts or products you are shipping.
          </p>
        </div>

        <p className={cn('pitch__summary')}>
          The Bill of Lading must be signed by an authorized representative of the carrier, shipper, and consignee to
          be valid.
        </p>

      </div>
    </section>
  );
  // return (
  //   <section className="section about">
  //     <div className="container">
  //       <h2 className="section-title">
  //         Who does <br className="mob-br" />a Bill of Lading involve?
  //       </h2>
  //       <p className="subtitle">Three people are directly connected to a Bill of Lading for any and all shipments:</p>

  //       <div className="text-box">
  //         <p className="text">
  //           The shipper is the entity providing the goods for transport. They handle the packing and preparation of
  //           the shipment, which could be a supplier or your own warehouse or manufacturing facility.
  //         </p>
  //         <p className="text">
  //           The carrier is the entity responsible for moving the cargo, such as Maersk or any other shipping line,
  //           trucking company, or airline.
  //         </p>
  //         <p className="text">
  //           The consignee is the designated recipient of the shipment, which could be your company or a manufacturer
  //           that requires the parts or products you are shipping.
  //         </p>
  //       </div>

  //       <p className="text">
  //         The Bill of Lading must be signed by an authorized representative of the carrier, shipper, and consignee to
  //         be valid.
  //       </p>
  //     </div>
  //   </section>
  // );
};

export default SectionPitch;